import React from 'react';

import { makeStyles, Theme, createStyles } from '@material-ui/core';
import { FiBriefcase, FiMapPin, FiUsers } from 'react-icons/fi';
import { RiVerifiedBadgeFill } from 'react-icons/ri';

import { ChatData } from '../../types';
import ChatAvatar from './ChatAvatar';
import { ChatListRow, chatListTime } from './kit';

const TYPE_ICONS: Partial<Record<ChatData['type'], React.ReactNode>> = {
  group: <FiUsers size={14} aria-label="Group" />,
  team: <FiUsers size={14} aria-label="Team" />,
  location: <FiMapPin size={14} aria-label="Site" />,
  company: <FiBriefcase size={14} aria-label="Company" />,
};

interface Props {
  chat: ChatData;
  onChatClick: (chat: ChatData) => void;
  selected: boolean;
  isLegend?: boolean;
}

// A messaging chat on the shared chat list row. Vyce's own chat is pinned on
// top and carries the verified mark.
export const ChatListItem: React.FC<Props> = ({ chat, onChatClick, selected, isLegend }) => {
  const classes = useStyles();
  const isVyceChat = chat.ownerId === 'vyce' && !isLegend;

  return (
    <ChatListRow
      avatar={
        <ChatAvatar
          borderWidth={0}
          avatarUrl={chat.avatarUrl}
          size={48}
          chatType={chat.type}
          name={chat.name || undefined}
        />
      }
      title={chat.name || ''}
      titleIcon={TYPE_ICONS[chat.type]}
      titleBadge={
        isVyceChat ? (
          <RiVerifiedBadgeFill size={16} className={classes.verified} aria-label="Vyce" />
        ) : undefined
      }
      time={chatListTime((chat.lastMessageTime?._seconds || 0) * 1000)}
      preview={chat.lastMessage || 'No messages yet'}
      unread={chat.hasUnread ? chat.unreadCount : 0}
      pinned={isVyceChat}
      selected={selected}
      onClick={() => onChatClick(chat)}
    />
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    verified: { flex: 'none', color: theme.palette.primary.main },
  })
);
